module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-23.3e951a3e.jpg";